import React, {useEffect, useState} from "react"
import {Button, Popconfirm, Table, Tooltip, Typography} from "antd"
import {useTranslation} from "react-i18next"
import {useSelector} from "react-redux";
import DeleteIcon from "../../../components/Icons/delete.svg";
import {colors, getRefArea, remove, setObjIndex, setUnitCosts, treeFromListResource} from "../helpers";
import axios from "axios";
import PriceDetails from "../priceDetails";
import ResourcesTable from "../resourcesTable";
import {FileTextOutlined} from "@ant-design/icons";

const {Text} = Typography;

const PtmListResources = (props) => {
    const {project, setProject, formState, titleForTable} = props
    const [state, setState] = useState(null)
    const [loading, setLoading] = useState(false)
    const [ptmInfo, setPtmInfo] = useState({visible: false, record: null});
    const [resInfo, setResInfo] = useState({visible: false, data: {}})
    const {t} = useTranslation(['common', 'nri', 'action', 'kit'])
    const referenceUnits = useSelector(state => state.referenceUnitReducer.list)

    useEffect(_ => {
        setPrice(project)
    }, [project, formState])

    function setPrice(project) {
        if (project.ptms.length > 0) {
            let treeData = treeFromListResource(project.ptms, 2)
            treeData = setUnitCosts(treeData, project.objects)
            const refUnitCode = referenceUnits.find(r => r.id === formState.referenceUnitId).code
            if (refUnitCode) {
                let x = getRefArea(refUnitCode)
                treeData = treeData.map(n => {
                    n.price = n[x] * formState.value
                    return n
                })
            }
            treeData = setObjIndex(treeData, project.objects)
            if (formState.vat) {
                let totalPrice = 0
                treeData.forEach((ptm) => {
                    totalPrice += ptm.price;
                });
                let nds = totalPrice * 0.2
                let totalRecord = {key: 999 + '_total', code: '', price: totalPrice, name: `Итого без НДС:`}
                let vatRecord = {key: 999 + '_vat', code: '', price: nds, name: `НДС:`}
                treeData.push(totalRecord)
                treeData.push(vatRecord)
            }
            setState(treeData)
        }
    }

    const columns = [
        {
            key: 'code',
            title: 'Код ПТМ',
            render: (key, record) => {
                let res = null
                if (record.priceDetails || record.ptmDescription || record.limited) {
                    res = <a
                        className='link'
                        onClick={() => showPtmDescription(record)}
                    >{record.code}</a>
                } else {
                    res = record.code
                }
                return <div style={{whiteSpace: 'nowrap'}}>{res}</div>
            }
        },
        {
            key: 'objCode',
            title: 'Код объекта',
            //ellipsis: true,
            render: (data) => <div style={{whiteSpace: 'nowrap', overflow: 'hidden'}}>{data.objCode}</div>
        },
        {
            key: 'regionName',
            title: t('nri:regionBuilt'),
            ellipsis: true,
            render: (data) => <div style={{whiteSpace: 'break-spaces', lineHeight: '1.1'}}>{data.regionName}</div>
        },
        {
            key: 'zoneCode',
            title: t('nri:zoneBuilt'),
            dataIndex: 'zoneCode',
            width: '5%',
            align: 'center',
        },
        {
            key: 'name',
            title: 'Наименование ПТМ',
            ellipsis: true,
            //dataIndex: 'name',
            width: '25%',
            render: (data) => data.name
        },
        {
            title: 'Ресурсы',
            children: [
                {
                    title: 'Материалы',
                    key: 'matt',
                    align: 'center',
                    render: (data) => {
                        if (data.resources?.ptmConstructionMaterialPrices?.length > 0) {
                            return (
                                <Tooltip title={t('kit:listOfMaterials')}>
                                    <a
                                        className='link'
                                        onClick={() => {
                                            let name = `ПТМ ${data.code}: ${data.name} ${t('kit:listOfMaterials')}`
                                            showResources(name, data.resources.ptmConstructionMaterialPrices)
                                        }}
                                    >
                                        {(data.level === 2) ? <FileTextOutlined style={{ fontSize: '18px'}} /> : (data.priceDetails?.matt)?.toFixed(3)}
                                    </a>
                                </Tooltip>
                            )
                        }
                    }
                },
                {
                    title: 'Машины и механизмы',
                    key: 'omach',
                    align: 'center',
                    render: (data) => {
                        if (data.resources?.ptmMechanismPrices?.length > 0) {
                            return (
                                <Tooltip title={t('kit:listOfCars')}>
                                    <a
                                        className='link'
                                        onClick={() => {
                                            let name = `ПТМ ${data.code}: ${data.name} ${t('kit:listOfCars')}`
                                            showResources(name, data.resources.ptmMechanismPrices)
                                        }}
                                    >
                                        {(data.level === 2) ? <FileTextOutlined style={{ fontSize: '18px'}} /> : (data.priceDetails?.omach)?.toFixed(3)}
                                    </a>
                                </Tooltip>
                            )
                        }
                    }
                    //render: (data) => data.priceDetails?.omach.toFixed(3)
                },
                {
                    title: 'Оборудование',
                    key: 'eqp',
                    align: 'center',
                    render: (data) => {
                        if (data.resources?.ptmEquipmentPrices?.length > 0) {
                            return (
                                <Tooltip title={t('kit:equipmentList')}>
                                    <a
                                        className='link'
                                        onClick={() => {
                                            let name = `ПТМ ${data.code}: ${data.name} ${t('kit:equipmentList')}`
                                            showResources(name, data.resources.ptmEquipmentPrices)
                                        }}
                                    >
                                        {(data.level === 2) ? <FileTextOutlined style={{ fontSize: '18px'}} /> : (data.priceDetails?.eqp)?.toFixed(3)}
                                    </a>
                                </Tooltip>
                            )
                        }
                    }
                },
            ],
        },
        {
            key: titleForTable.data,
            title: titleForTable.title2,
            align: 'center',
            render: (data) => data[titleForTable.data]?.toFixed(3)
        },
        {
            key: 'price',
            title: 'Стоимость руб.',
            //dataIndex: 'price',
            align: 'center',
            width: '9%',
            render: (data) => data.price?.toFixed(3)
        },
        {
            dataIndex: "key",
            key: 'key',
            width: 30,
            render: (key, record) => {
                if (record.level <= 5) {
                    return (
                        <div className="changeIcon">
                            <Popconfirm
                                cancelText={t('common:no')}
                                okText={t('common:yes')}
                                placement="left"
                                title={t('valid:sureToDelete')}
                                onCancel={(e) => {
                                    e.stopPropagation()
                                    return null
                                }}
                                onConfirm={(e) => {
                                    e.stopPropagation()
                                    remove(key, project, setProject)
                                }}
                            >
                                <img alt=""
                                    src={DeleteIcon}
                                    title={t('action:delete')}
                                />
                            </Popconfirm>
                        </div>
                    )
                }
            }
        }
    ];

    const expandedRowRender = (record, i) => {
        const index = project.ptms.findIndex(n => n.key === record.key)
        if (!loading && record.smId && index > 0 && !project.ptms[index]?.resources) {
            setLoading(true)
            axios.get("/jsonLine/getResources", {
                params: {
                    smetaId: record.smId,
                    rePtmId: record.rePtmId,
                    rePtmProjId: record.priceDetails?.rePtmProjId
                }
            }).then(res => res.data)
                .then(res => {
                    let data = res.map((el, idx) => ({key: el.id, ...el}))
                    let ptms = [...project.ptms]
                    ptms[index].resources = data
                    //setProject(ptms)
                })
                .finally(() => setLoading(false))

        }
        //return selectedPtms[index]?.resources && <Table columns={columnResources} dataSource={[...selectedPtms[index].resources]} />;
    };

    const showPtmDescription = (record) => {
        setPtmInfo({visible: true, record: record})
    }

    const showResources = (name, resources) => {
        let data = {name: name, resources: resources}
        setResInfo({visible: true, data: data})
    }

    function getClasses(record) {
        let cls = ''
        if (record.index !== undefined)
            cls = colors[record.index]?.replace('#', '')
        if (!record.children && !record.priceDetails) {
            if (cls) cls += " "
            cls += "hide-expand-icon"
        }
        return cls
    }

    return (<>
            <Table
                columns={columns}
                dataSource={state?.map((el, idx) => ({key: idx, ...el}))}
                pagination={false}
                size="small"
                style={{paddingBottom: "20px"}}
                className='ptmList'
                loading={loading}
                rowClassName={(record) => colors[record.index]?.replace('#', '')}
                bordered
                //scroll={{ x: 'calc(700px + 50%)' }}
                /*expandable={{
                    expandedRowRender,
                    defaultExpandedRowKeys: ['0'],
                    rowExpandable: (record) => record.children || record.priceDetails,
                }}*/
                summary={(pageData) => {
                    let totalPrice = 0;
                    pageData.forEach(({key, price}) => {
                        if (!key.includes('999_total'))
                            totalPrice += price;
                    });
                    return (
                        <Table.Summary fixed>
                            <Table.Summary.Row>
                                <Table.Summary.Cell index={0} colSpan={4}>
                                    <div className="changeIcon">
                                        <Popconfirm
                                            cancelText={t('common:no')}
                                            okText={t('common:yes')}
                                            placement="left"
                                            title={t('kit:sureToDelPtm')}
                                            onCancel={(e) => {
                                                e.stopPropagation()
                                                return null
                                            }}
                                            onConfirm={(e) => {
                                                e.stopPropagation()
                                                setProject({ptms: [], objects: []})
                                            }}
                                        >
                                            <Button danger>
                                                <a>{t('kit:cleanTable')}</a>
                                            </Button>
                                        </Popconfirm>
                                    </div>
                                </Table.Summary.Cell>
                                <Table.Summary.Cell index={1} colSpan={5}>Итого:</Table.Summary.Cell>
                                <Table.Summary.Cell index={2}>
                                    <Text type="danger">{totalPrice?.toFixed(3)}</Text>
                                </Table.Summary.Cell>
                            </Table.Summary.Row>
                        </Table.Summary>
                    )
                }}
            />
            {ptmInfo.visible &&
                <PriceDetails
                    ptmInfo={ptmInfo}
                    setPtmInfo={setPtmInfo}
                />
            }
            {resInfo.visible &&
                <ResourcesTable
                    resInfo={resInfo}
                    setResInfo={setResInfo}
                />
            }
        </>
    )
}
export default PtmListResources